import React, { Fragment, useEffect } from 'react'
import AuthService from '../../services/auth'
import { MSAL_AUTHENTICATION_PARAMETERS } from '../../utils/auth'
const Spinner = require('../../assets/icons/ui/loader.gif')
const flowLaunchRequest = {   
  ...MSAL_AUTHENTICATION_PARAMETERS,
  auth: {
    ...(MSAL_AUTHENTICATION_PARAMETERS.auth || {}),
    redirectUri: "",
  },
}
const IdentityRedirectPage = () => {
  const authService = new AuthService()

  useEffect(() => {
    let params = (new URL(window.location)).searchParams
    let iamAction = params.get("iam_action")
    if (iamAction !== null) {
      iamAction = iamAction.toLocaleLowerCase()
    }
    let authority = undefined
    if (iamAction === "forgotusername") {
      authority = process.env.REACT_APP_MSAL_FORGOT_USERNAME_AUTHORITY
      /// redirect uri can be left as is because the currently set redirect uri will trigger sign-in, which is the goal
    }
    if (iamAction === "createprofile") {
      authority = process.env.REACT_APP_MSAL_CREATE_PROFILE_AUTHORITY
      flowLaunchRequest.auth.redirectUri = process.env.REACT_APP_DASHBOARD_URL
    }
    if (iamAction === "signin") {
      authority = process.env.REACT_APP_MSAL_CONVERT_MERGE_SIGNIN_AUTHORITY
      flowLaunchRequest.auth.redirectUri = process.env.REACT_APP_MSAL_REDIRECT_URI
    }
    if (authority === undefined) {
      //console.warn(`Unrecognized iam_action param: ${iamAction}`)
    }
    authService._msalApp.authority = authority
    authService.loginRedirect(flowLaunchRequest)
    // eslint-disable-next-line
  }, []) 
  // not including auth service as a dependency

  return (
    <Fragment>
      <div className="loading-spinner"> 
        <img src={Spinner} className ="spinner-alignment" alt="Icon"/>
        <span className="loading-message">Loading .....</span>
        <span>Please wait while we redirect you</span>
      </div>
    </Fragment>
  )
}

export default IdentityRedirectPage 